package org.gymly.navigation

import org.gymly.model.AdminRoute
import org.gymly.model.PortalTab

object WebHistory {
    fun adminHash(route: AdminRoute): String = "#/admin/${route.webSlug()}"

    fun portalHash(tab: PortalTab): String = "#/portal/${tab.webSlug()}"

    fun loginHash(): String = "#/"

    fun isAdminHash(hash: String): Boolean =
        hash.removePrefix("#").trim().trimStart('/').lowercase().startsWith("admin")

    fun isPortalHash(hash: String): Boolean =
        hash.removePrefix("#").trim().trimStart('/').lowercase().startsWith("portal")

    fun isLoginHash(hash: String): Boolean =
        !isAdminHash(hash) && !isPortalHash(hash)

    fun parseAdminRoute(hash: String): AdminRoute? {
        val slug = hash
            .removePrefix("#")
            .trim()
            .trimStart('/')
            .lowercase()
            .removePrefix("admin")
            .trimStart('/')
        if (slug.isEmpty()) return AdminRoute.Dashboard
        return AdminRoute.entries.firstOrNull { it.webSlug() == slug }
    }

    fun parsePortalTab(hash: String): PortalTab? {
        val slug = hash
            .removePrefix("#")
            .trim()
            .trimStart('/')
            .lowercase()
            .removePrefix("portal")
            .trimStart('/')
        if (slug.isEmpty()) return PortalTab.Home
        return PortalTab.entries.firstOrNull { it.webSlug() == slug }
    }
}

fun AdminRoute.webSlug(): String = when (this) {
    AdminRoute.Dashboard -> "dashboard"
    AdminRoute.BulkSignup -> "bulk-signup"
    AdminRoute.Clients -> "clients"
    AdminRoute.Workers -> "workers"
    AdminRoute.Services -> "services"
    AdminRoute.MembershipPlans -> "membership-plans"
    AdminRoute.MembershipOrders -> "membership-orders"
    AdminRoute.Memberships -> "memberships"
    AdminRoute.ClientAccounts -> "client-accounts"
    AdminRoute.Orders -> "orders"
    AdminRoute.Payments -> "payments"
    AdminRoute.Marketing -> "marketing"
    AdminRoute.Products -> "products"
    AdminRoute.StoreSales -> "store-sales"
    AdminRoute.Schedules -> "schedules"
    AdminRoute.Bookings -> "bookings"
    AdminRoute.Profile -> "profile"
    AdminRoute.Reports -> "reports"
    AdminRoute.Settings -> "settings"
    AdminRoute.TermsMonitoring -> "terms-monitoring"
}

fun PortalTab.webSlug(): String = when (this) {
    PortalTab.Home -> "home"
    PortalTab.Schedules -> "schedules"
    PortalTab.Bookings -> "bookings"
    PortalTab.Store -> "store"
    PortalTab.Payments -> "payments"
    PortalTab.Profile -> "profile"
    PortalTab.Terms -> "terms"
}

/** Actualiza la URL del navegador (hash). En otras plataformas no hace nada. */
expect fun pushWebHash(hash: String, replace: Boolean = false)

/** Hash actual (`#/admin/...`, `#/portal/...`, etc.). Vacío fuera de web. */
expect fun currentWebHash(): String

/** Origen y ruta de la página web (sin hash). Vacío fuera de la web. */
expect fun currentWebPageUrl(): String

/** Escucha atrás/adelante del navegador. Devuelve función para quitar el listener. */
expect fun installWebHashListener(onChange: () -> Unit): () -> Unit
